module.exports = {
  psychologicalHotline: {
    psychologicalHotline: '心理热线'
  }
}


// WEBPACK FOOTER //
// ./src/i18n/psychologicalHotline/en.js